import { render } from "./ComponentePrograma.vue?vue&type=template&id=682e2a19"
import script from "./ComponentePrograma.vue?vue&type=script&lang=js"
export * from "./ComponentePrograma.vue?vue&type=script&lang=js"

import "./ComponentePrograma.vue?vue&type=style&index=0&id=682e2a19&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__